import React from "react";
import {CardActionArea, Paper, Typography} from "@mui/material";
import icons from "~/catalog/components/icons";
import {Settings} from "@mui/icons-material";
import {Application} from "~/catalog/hooks";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";


export type CatalogGridItemProps = {
    disabled?: boolean
    onClick?: () => any
    application: Application
}


const useStyles = makeStyles<PortTheme, CatalogGridItemProps>(theme => ({
    root: {
        width: 88
    },
    card: {
        borderRadius: 8,
        width: 88,
        height: 78,
        position: "relative",
        filter: "drop-shadow(0px 2.49596px 14.9758px rgba(104, 117, 130, 0.09))",
        "& .MuiPaper-root": {
            borderRadius: 8,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
                fontSize: 54,
                opacity: props => props.disabled ? 0.15 : 1,
            }
        },
        marginBottom: 4,
    },
    badge: {
        position: "absolute",
        right: 3,
        top: 4,
        borderRadius: 12,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: 9,
        fontWeight: 700,
        color: "white",
        backgroundColor: props => ({
            new: "#009ACF",
            soon: "#3F79B5",
            locked: "#6E798C"
        }[props.application.badge])
    },
    title: {
        lineHeight: "14px"
    }
}))


export const CatalogGridItem = (props: CatalogGridItemProps) => {
    const {disabled, onClick, application} = props;
    const classes = useStyles(props);


    const handleClick = () => {
        if (!disabled) {
            onClick && onClick();
        }
    }

    const Icon = icons[application.iconName] || Settings;

    return (
        <div className={classes.root}>
            <CardActionArea disabled={disabled} onClick={handleClick} className={classes.card}>
                <Paper elevation={4}>
                    <Icon/>
                </Paper>
                {application.badge && (
                    <div className={classes.badge}>
                        {{
                            new: "Новый",
                            soon: "Скоро",
                        }[application.badge]}
                    </div>
                )}
            </CardActionArea>
            <Typography variant="cardMenuTitle" align="center" display="block" color="secondary" className={classes.title}>
                {application.name}
            </Typography>
        </div>
    )
}